export const COOKIE_EXPIRATION_DAYS = 730;
export const CAMPAIGN_KEYWORDS: ReadonlyArray<string> = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'twclid', // X conversion should be part of utm params so it will be sent to tracking-api during signup request
];
